import type { ReactNode } from 'react';
import React from 'react';
import { SuccessIcon } from '@lt/components/icons-react/auth';
import { i18n } from '@lt/localization';
import styles from './authSuccess.module.css';

type Props = {
  label?: ReactNode;
};

export const AuthSuccess = ({
  label = i18n.t('checkout.authSuccess'),
}: Props) => (
  <div className={styles.wrapper}>
    <SuccessIcon width={24} height={24} />
    {label}
  </div>
);
